import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { ReportChart } from '@/components/relatorios/ReportChart'
import { ReportKpiCard } from '@/components/relatorios/ReportKpiCard'
import { ReportShell } from '@/components/relatorios/ReportShell'
import { ReportTable } from '@/components/relatorios/ReportTable'
import { exportCsv } from '@/components/relatorios/reportUtils'
import { useLeadEntryReport } from '@/hooks/reports/reportHooks'
import { useReportDateRange } from '@/hooks/reports/useReportDateRange'

export default function EntradaLeadsReport() {
  const [range, setRange] = useReportDateRange()
  const report = useLeadEntryReport(range)
  const total = report.data.reduce((sum, row) => sum + row.leads, 0)
  const chartRows = report.data.map((row) => ({
    ...row,
    label: format(parseISO(row.date), 'dd/MM'),
  }))

  return (
    <ReportShell
      title="Entrada de leads"
      description="Contatos individuais criados no período, agrupados por dia."
      {...range}
      onRangeChange={setRange}
      loading={report.loading}
      error={report.error}
      empty={!report.data.some((row) => row.leads > 0)}
      onRetry={report.refetch}
      onExport={() => exportCsv('entrada-leads', report.data, [
        { label: 'Data', value: (row) => row.date },
        { label: 'Leads', value: (row) => row.leads },
      ])}
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <ReportKpiCard label="Leads no período" value={total.toLocaleString('pt-BR')} />
        <ReportKpiCard label="Média por dia" value={(total / Math.max(report.data.length, 1)).toLocaleString('pt-BR', { maximumFractionDigits: 1 })} />
      </div>
      <ReportChart
        data={chartRows}
        xKey="label"
        series={[{ key: 'leads', label: 'Leads', color: 'var(--primary)' }]}
      />
      <ReportTable
        rows={report.data}
        rowKey={(row) => row.date}
        columns={[
          { key: 'date', label: 'Data', render: (row) => format(parseISO(row.date), 'dd/MM/yyyy', { locale: ptBR }) },
          { key: 'leads', label: 'Leads', align: 'right', render: (row) => row.leads.toLocaleString('pt-BR') },
        ]}
      />
    </ReportShell>
  )
}
